var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo d-flex align-items-center"},[_c('a',{staticClass:"square fm-14",attrs:{"href":"#"}},[_vm._v("SQUARE+")]),_c('a',{staticClass:"master_coach_admin_page fm-16",attrs:{"href":"#"}},[_vm._v("마스터코치 관리자 페이지")])])
}]

export { render, staticRenderFns }